<template>
    <div>         
        <!-- CONTENIDO PRINCIPAL -->
         <div class="container contenido_principal" style="margin-bottom:5rem">
            <boton-atras :nombre_ruta="'informacion'"></boton-atras>
             <div>
                <div>
                    <h6 class="subtitulo mb-2">FOPROVEP.- Primas de aseguramiento</h6>
                    <div class="lineaNegra"></div><div class="mt-1 mb-2 lineaNegra2"></div>
                </div>
                <div class="parrafo-contenido mb-3">
                  Se toma como fundamento lo establecido en la tabla de costos que dicta el numeral 20, de las Reglas de Operación del FOPROVEP y es la siguiente:
                </div> 
                <!-- Tabla -->
                <!-- <div class="table-responsive"> -->
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                            <th scope="col">TIPO</th>
                            <th scope="col">MODELOS</th>
                            <th scope="col">COSTO</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Motocicletas y similares</td>
                                <td>Todos los modelos</td>
                                <td>$ 500.00</td>
                            </tr>
                            <tr>
                                <td>Automóviles</td>
                                <td>1989 y anteriores</td>
                                <td>$ 1,300.00</td>
                            </tr>
                            <tr>
                                <td>Automóviles</td>
                                <td>1990-1992</td>
                                <td>$ 1,800.00</td>
                            </tr>
                            <tr>
                                <td>Automóviles</td>
                                <td>1993-1995</td>
                                <td>$ 2,300.00</td>
                            </tr>
                            <tr>
                                <td>Automóviles</td>
                                <td>1996 en adelante</td>
                                <td>$ 2,800.00</td>
                            </tr>
                            <tr>
                                <td>Camionetas</td>
                                <td>Todos los tipos y modelos</td>
                                <td>$ 2,800.00</td>
                            </tr>
                            <tr>
                                <td>Camiones 3 toneladas o mayores</td>
                                <td>Todos los modelos</td>
                                <td>$ 4,000.00</td>
                            </tr>
                            <tr>
                                <td>Autobuses</td>
                                <td>Todos los modelos</td>
                                <td>$ 4,000.00</td>
                            </tr>
                            <tr>
                                <td>Tractocamiones</td>
                                <td>Todos los modelos</td>
                                <td>$ 4,000.00</td>
                            </tr>
                        </tbody>
                    </table>

                <!-- </div> -->
               
                
            </div>
             
            
         </div>
    </div>
</template>
<script>
import botonAtras from './../../button-atras'
export default {
    data: function(){
        return{
            // variables
        }
    },
    components:{
        botonAtras
    }
}
</script>

<style scoped>
/* Estilos para moviles */
@media only screen and (max-device-width : 900px) {
    .subtitulo{ 
        font-size: 1.4rem !important;
        margin-top: 1.6rem !important;
    }
    .contenido_principal h5{ font-size: 1rem; }
    .parrafo-contenido{ font-size: 1em !important; }

     table{
        font-size: 12.5px;
    }
    tbody tr td{
        padding-left: 0;
        padding-right: 0;
    }
}

.parrafo-contenido{
    font-size: 1.3em;
    line-height: 1.8em;
}

thead{
    background-color: #621132;
    color: white;
    opacity: 0.7;
}
table, thead th{
    text-align: center;
}




</style>